import numeral from 'numeral';
export var numberWithCommas = function numberWithCommas(input) {
  return numeral(input).format('O,O');
};
export var numberAsCurrency = function numberAsCurrency(input) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
  return numeral(input).format("O,O.".concat(new Array(precision).fill('O').join('')));
};
export var numberWithPercent = function numberWithPercent(input) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var format = !Number.isFinite(precision) ? 'O.OO%' : "O.".concat(new Array(precision).fill('O').join(''), "%");
  return numeral(input).format(format);
};
export var numberWithSuffix = function numberWithSuffix(input) {
  return numeral(input).format('Oo');
};